import i from './erp-payment-log.container';

export default i;
